import React from "react";
import { makeStyles } from '@material-ui/core/styles';
export default function LinearProgress({
  ...props
}) {
  const {
    value,
    inTable,
    color
  } = props;
  const useStyles = makeStyles(theme => ({
    root: {
      width: '100%',
      height: 22,
      margin: 5,
      background: '#ecf0f1',
      border: `1px solid ${theme.palette.divider}`,
      borderRadius: 10,
      color: '#000',
      textAlign: 'center',
      fontSize: 14,
      direction: 'ltr',
      position: 'relative'
    },
    bar: {
      width: `${value}%`,
      display: value ? 'block' : 'none',
      maxWidth: '100%',
      height: 20,
      borderRadius: 10,
      '&.low': {
        background: '#f44336',
        border: `1px solid #f44336`
      },
      '&.medium': {
        background: '#f39c12',
        border: `1px solid #f39c12`
      },
      '&.high': {
        background: '#61af61',
        border: `1px solid #61af61`
      },
      '&.custom': {
        background: `${color}`,
        border: `1px solid ${color}`
      }
    },
    value: {
      position: 'absolute',
      top: inTable ? -6 : 1,
      width: '100%',
      left: 0
    }
  }));
  const classes = useStyles();
  let className = '';
  if(color) {
    className = `${classes.bar} custom`;
  }
  else if (value < 50) {
    className = `${classes.bar} low`;
  } else if (value > 49 && value < 75) {
    className = `${classes.bar} medium`;
  } else if(value > 74) {
    className = `${classes.bar} high`;
  }
  return <React.Fragment>
       <div className={classes.root}>
            <div className={className}>
              
            </div>
            <div className={classes.value}> {value}% </div>
       </div>
    </React.Fragment>;
}